import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import Swal from "sweetalert2";
import { UncontrolledTooltip } from "reactstrap";
import { showToast } from "../../../components/ToastifyNotification";
import { DeleteCase, GetCases } from "../../../api/masters/caseAPI";

const ListCase = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Fetch consultants list
  const fetchCases = async () => {
    dispatch({ type: "LOADER_START" });
    try {
      const res = await GetCases();
      if (res.success) {
        showToast("success", res.message);
        const formatted = res.data.map((item, index) => ({
          index: index + 1,
          id: item._id,
          name: item.name,
          department: item.departmentId?.name || "",
          ob: item.ob,
        }));
        setData(formatted);
        setFilteredData(formatted);
      } else {
        showToast("error", res.message);
      }
    } catch (err) {
      showToast("error", err.message);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  useEffect(() => {
    fetchCases();
  }, []);

  // Search filter
  useEffect(() => {
    const results = data.filter(item =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredData(results);
  }, [search, data]);

  // Handle Edit
  const handleEditClick = (id) => {
    navigate(`/masters/case/edit/${id}`);
  };

  // Handle Delete
  const handleDeleteClick = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: "LOADER_START" });
        try {
          const res = await DeleteCase(id);
          if (res.success) {
            showToast("success", res.message);
            const updated = data.filter((item) => item.id !== id);
            setData(updated);
            setFilteredData(updated);
          } else {
            showToast("error", res.message);
          }
        } catch (err) {
          showToast("error", err.message);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      }
    });
  };

  // DataTable Columns
  const columns = [
    { name: "S.No", selector: (row) => row.index, width: "10%", sortable: true },
    { name: "Name", selector: (row) => row.name, sortable: true, width: "25%" },
    { name: "Department", selector: (row) => row.department, sortable: true, width: "25%" },
    { name: "OB", selector: (row) => row.ob, sortable: true, width: "20%" },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            className="btn btn-primary me-2"
            id={`edit-${row.id}`}
            onClick={() => handleEditClick(row.id)}
          >
            <i className="fa fa-pencil-square-o" />
          </button>
          <UncontrolledTooltip placement="top" target={`edit-${row.id}`}>
            Edit
          </UncontrolledTooltip>
          <button
            className="btn btn-danger"
            id={`delete-${row.id}`}
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="fa fa-trash-o" />
          </button>
          <UncontrolledTooltip placement="top" target={`delete-${row.id}`}>
            Delete
          </UncontrolledTooltip>
        </div>
      ),
      ignoreRowClick: true,
      button: true,
      width: "20%"
    },
  ];

  // CSV Export
  const headers = [
    { label: "S.No", key: "index" },
    { label: "Name", key: "name" },
    { label: "Department", key: "department" },
    { label: "OB", key: "ob" },
  ];

  const ExportCSV = ({ data }) => (
    <CSVLink data={data} headers={headers} filename="cases.csv">
      <button className="btn btn-primary" id="export" style={{ marginTop: "5px" }}>
        Export
      </button>
      <UncontrolledTooltip placement="top" target="export">
        Export to CSV
      </UncontrolledTooltip>
    </CSVLink>
  );

  return (
    <Fragment>
      <Breadcrumb parent="Case" title="List Case" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <h5>List Case</h5>
                  <Link to={`/masters/case/add`}>
                    <button className="btn btn-primary" id="create">
                      Create Case
                    </button>
                    <UncontrolledTooltip placement="top" target="create">
                      Create Case
                    </UncontrolledTooltip>
                  </Link>
                </div>

                <div className="row mt-2">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Cases..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6 text-end">
                    <ExportCSV data={filteredData} />
                  </div>
                </div>
              </div>

              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  highlightOnHover
                  persistTableHead
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListCase;
